<template>
    <div class="bg-image">
        <div class="hero-static bg-white-95">
            <div class="content">
                <div class="row justify-content-center">
                    <div class="col-md-8 col-lg-6 col-xl-4">
                        <div class="block block-themed block-fx-shadow mb-0">

                            <!-- ===== STEP 1: Email + Password ===== -->
                            <template v-if="step === 'credentials'">
                                <div class="block-header">
                                    <h3 class="block-title">LOGIN</h3>
                                    <router-link to="/recupera-password">
                                        <div class="block-options">
                                            <a class="btn-block-option font-size-sm">Password dimenticata?</a>
                                        </div>
                                    </router-link>
                                </div>
                                <div class="block-content">
                                    <div class="p-sm-3 px-lg-4 py-lg-5">
                                        <h1 class="mb-2">Agritek 26</h1>
                                        <p>Il portale di Agritek 26 dedicato ai propri periti assicurativi.</p>

                                        <ValidationObserver ref="observer" v-slot="{ invalid }">
                                            <form class="js-validation-signin">
                                                <div class="py-3">
                                                    <div class="form-group">
                                                        <label>Email</label>
                                                        <ValidationProvider rules="required|email" name="Email" v-slot="{ errors }">
                                                            <input v-model="email" type="text" class="form-control" placeholder="Email">
                                                            <span class="validation-error">{{ errors[0] }}</span>
                                                        </ValidationProvider>
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Password</label>
                                                        <ValidationProvider rules="required" name="Password" v-slot="{ errors }">
                                                            <input v-model="password" type="password" class="form-control" placeholder="Password">
                                                            <span class="validation-error">{{ errors[0] }}</span>
                                                        </ValidationProvider>
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <div class="col-md-6 col-xl-5">
                                                        <button :disabled="invalid" v-on:click.prevent="login" class="btn btn-block btn-primary">
                                                            <i class="fa fa-fw fa-sign-in-alt mr-1"></i> Entra
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </ValidationObserver>
                                    </div>
                                </div>
                            </template>

                            <!-- ===== STEP 2: Codice Google Authenticator ===== -->
                            <template v-if="step === '2fa'">
                                <div class="block-header">
                                    <h3 class="block-title">Verifica in due passaggi</h3>
                                </div>
                                <div class="block-content">
                                    <div class="p-sm-3 px-lg-4 py-lg-5">

                                        <div class="text-center mb-4">
                                            <i class="fa fa-shield-alt fa-3x text-primary mb-3"></i>
                                            <p class="mb-1"><strong>Microsoft Authenticator</strong> o <strong>Google Authenticator</strong></p>
                                            <p class="text-muted font-size-sm">
                                                Inserisci il codice a 6 cifre mostrato nell'app per completare il login.
                                            </p>
                                        </div>

                                        <ValidationObserver ref="observer2fa" v-slot="{ invalid }">
                                            <form>
                                                <div class="form-group">
                                                    <label>Codice OTP</label>
                                                    <ValidationProvider rules="required|digits:6" name="Codice OTP" v-slot="{ errors }">
                                                        <input
                                                            v-model="otpCode"
                                                            type="text"
                                                            class="form-control text-center font-size-h4 ls-3"
                                                            placeholder="000000"
                                                            maxlength="6"
                                                            autocomplete="one-time-code"
                                                            inputmode="numeric"
                                                            ref="otpInput"
                                                            @keyup.enter="verify2fa"
                                                        >
                                                        <span class="validation-error">{{ errors[0] }}</span>
                                                    </ValidationProvider>
                                                </div>

                                                <div class="form-group row mt-3">
                                                    <div class="col-6">
                                                        <button type="button" v-on:click="backToCredentials" class="btn btn-block btn-light">
                                                            <i class="fa fa-arrow-left mr-1"></i> Indietro
                                                        </button>
                                                    </div>
                                                    <div class="col-6">
                                                        <button :disabled="invalid" v-on:click.prevent="verify2fa" class="btn btn-block btn-primary">
                                                            <i class="fa fa-check mr-1"></i> Verifica
                                                        </button>
                                                    </div>
                                                </div>

                                                <p v-if="otpError" class="text-danger text-center mt-2">
                                                    <i class="fa fa-exclamation-circle mr-1"></i>{{ otpError }}
                                                </p>
                                            </form>
                                        </ValidationObserver>
                                    </div>
                                </div>
                            </template>

                        </div>
                    </div>
                </div>
            </div>
            <Copyright />
        </div>
    </div>
</template>

<script>
import Copyright from '../components/Copyright'
import AuthenticationRepository from '../services/apis/authentication'
import UserRepository from '../services/apis/user'

export default {
    data() {
        return {
            // Step: 'credentials' | '2fa'
            step: 'credentials',

            // Step 1
            email: '',
            password: '',

            // Step 2
            otpCode: '',
            otpError: '',
            pendingToken: '',   // token temporaneo restituito dal backend

            // Shared
            authProps: ''
        }
    },
    components: {
        Copyright,
    },
    methods: {
        // ------------------------------------------------------------------
        // STEP 1 – credenziali email/password
        // ------------------------------------------------------------------
        login: async function () {
            this.$store.dispatch('updateLoadingState', true)

            const obj = {
                email:    this.email,
                password: this.password,
            }

            let auth = await AuthenticationRepository.login(obj).catch((err) => {
                if (err.status == 401) {
                    this.$toasted.error('Errore: email o password non validi').goAway(3000)
                }
            })

            this.$store.dispatch('updateLoadingState', false)

            if (!auth) return

            const status = auth.data.status

            // Il backend richiede il 2FA
            if (status === '2fa_required') {
                this.pendingToken = auth.data.pending_token
                this.step = '2fa'
                this.$nextTick(() => {
                    this.$refs.otpInput && this.$refs.otpInput.focus()
                })
                return
            }

            // Login diretto (utente senza 2FA)
            if (status === 'success') {
                this.authProps = auth
                await this.afterLogin()
            }
        },

        // ------------------------------------------------------------------
        // STEP 2 – verifica codice OTP
        // ------------------------------------------------------------------
        verify2fa: async function () {
            this.otpError = ''
            this.$store.dispatch('updateLoadingState', true)

            const obj = {
                pending_token: this.pendingToken,
                otp_code:      this.otpCode,
            }

            let auth = await AuthenticationRepository.verify2fa(obj).catch((err) => {
                this.otpError = err?.data?.message || 'Codice OTP non valido.'
            })

            this.$store.dispatch('updateLoadingState', false)

            if (!auth) return

            if (auth.data.status === 'success') {
                this.authProps = auth
                await this.afterLogin()
            } else {
                this.otpError = auth.data.message || 'Codice non valido.'
                this.otpCode  = ''
            }
        },

        // ------------------------------------------------------------------
        // Torna allo step credenziali e resetta lo stato OTP
        // ------------------------------------------------------------------
        backToCredentials() {
            this.step         = 'credentials'
            this.otpCode      = ''
            this.otpError     = ''
            this.pendingToken = ''
        },

        // ------------------------------------------------------------------
        // Finalizza il login (comune a entrambi i percorsi)
        // ------------------------------------------------------------------
        async afterLogin() {
            this.$store.dispatch('updateAccessTokenState', this.authProps.data.data.token)

            let user = this.authProps.data.data.user
            user.service_token = this.authProps.data.data.service_token

            this.$store.dispatch('updateUserObjState', user)
            this.$store.dispatch('updateLogginState', true)

            if (this.authProps.data.data.user.role === 'perito') {
                const _resp = await UserRepository.get_ispettori_associati().catch(() => {})
                if (_resp) {
                    this.$store.dispatch('updateIspettoriObjState', _resp.data.data)
                }
            }

            if (
                this.authProps.data.data.user.role != 'perito' &&
                this.authProps.data.data.user.role != 'ispettore'
            ) {
                this.$store.dispatch('updateChoiseState', 'specifiche')
                this.$router.push({ name: 'dashboard' })
            } else {
                this.$router.push({ name: 'scegli-sezione' })
            }
        },
    },
    mounted() {
        this.$store.dispatch('updateLoadingState', false)
    }
}
</script>